// @flow

import React, { Component } from 'react';
import radium from 'radium';

import topBackground from '../static/images/topBackground.png';
import bottomBackground from '../static/images/bottomBackground.png';
import twoStrike from '../static/images/Block5/twoStrike.png';
import logo from '../static/images/logo.png';

import Block1 from './Block1.jsx';
import Block2 from './Block2.jsx';
import Block3 from './Block3.jsx';
import Block4 from './Block4.jsx';
import Block5 from './Block5.jsx';
import ScoreContext from '../scoreContext';

const styles = {
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  wrapperBackground: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundPosititon: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    width: '100%',
    // padding: '12px 12px',
  },
  twoStrikeLogo: {
    width: 150,
  },
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '20px 0 30px 0',
  },
  footerText: {
    fontSize: 10,
    color: 'white',
    letterSpacing: 2.31,
    margin: 0,
    '@media (max-width: 479px)': {
      letterSpacing: 0.8,
    },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 0 10px 0',
  },
  gradient: {
    width: '100%',
    height: 100,
    background: 'linear-gradient(to bottom, rgba(166,203,88,1) 0%,rgba(162,192,110,1) 100%)',
  },
};


class HomePage extends Component {
  render() {
    return (
      <div style={styles.wrapper}>
        <div style={[styles.wrapperBackground, { backgroundImage: `url(${topBackground})` }]}>
          <Block1 />
          <ScoreContext.Consumer>
            {({
              likes,
              shares,
              comments,
            }) => (
              <Block2
                comments={Number(comments)}
                shares={Number(shares)}
                likes={Number(likes)} />
            )}
          </ScoreContext.Consumer>
          <Block3 />
          <Block4 />
        </div>
        <div style={[styles.wrapperBackground, { backgroundImage: `url(${bottomBackground})` }]}>
          <Block5 />
        </div>
      </div>
    );
  }
}

export default radium(HomePage);
